import ForumLandingFormModule from './containers/forumLandingFormModule'

export {default as ForumLandingFormModuleLayout} from './components/forumLandingFormModuleLayout'

export default ForumLandingFormModule
